import { createSelector } from 'reselect';
import _get from 'lodash/get';
import getNumberOfDays from 'yoda-site-components/lib/dates/DateFormatter/GetNumberOfDays';
import getDeliveryDateType from '../../helpers/GetDeliveryDateType';

const getBundleItemOffering = (state) => state.bundleItemOffering;

const getBundleProductDeliveryType = createSelector(
    [getBundleItemOffering],
    (bundleItemOffering = {}) => {
        const inventoryData = Object.keys(bundleItemOffering);
        let bundleDeliveryTypeForAnalytics = {};
        if (inventoryData.length) {
            inventoryData.forEach((ppid) => {
                if (_get(bundleItemOffering, [ppid, 'promise'])) {
                    const serviceLevels = _get(
                        bundleItemOffering[ppid].promise,
                        'skuDeliveryOptions[0].deliveryOptions.shipToHome.serviceLevels[0]',
                        {}
                    );
                    const deliveryDate = _get(serviceLevels, 'deliveryDate', '');
                    const deliveryTypeForAnalytics = serviceLevels
                        ? getDeliveryDateType(deliveryDate)
                        : '';
                    const deliveryDaysForAnalytics = serviceLevels
                        ? getNumberOfDays(deliveryDate)
                        : '';
                    bundleDeliveryTypeForAnalytics = {
                        ...bundleDeliveryTypeForAnalytics,
                        [`${ppid}-type`]: {
                            deliveryTypeForAnalytics,
                        },
                        [`${ppid}-days`]: {
                            deliveryDaysForAnalytics,
                        },
                    };
                }
            });
        }
        return bundleDeliveryTypeForAnalytics;
    }
);

export default getBundleProductDeliveryType;
